import { Box, Stack, Typography, TextField, InputAdornment } from '@mui/material';
import { useState, useMemo } from 'react';
import { ReleasesList } from './ReleasesList';
import { useReleases } from './useReleases';
import { ShContainer } from 'shared/SharedStyles/ShLayouts';
import SearchIcon from '@mui/icons-material/Search';

export const Releases = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const { releases } = useReleases();

    const filteredReleases = useMemo(() => {
        if (!searchQuery) return releases;
        
        const query = searchQuery.toLowerCase();
        return releases.filter(release => 
            release.title.toLowerCase().includes(query) ||
            release.description.toLowerCase().includes(query) ||
            (release.version?.toLowerCase() || '').includes(query) ||
            release.type.toLowerCase().includes(query) ||
            release.changes?.some(change => change.toLowerCase().includes(query))
        );
    }, [releases, searchQuery]);

    return (
        <ShContainer maxWidth="xl">
            <Stack direction="row" alignItems="center" mb={4}>
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Release History
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Track our latest features, improvements, and bug fixes
                    </Typography>
                </Box>
            </Stack>

            <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Search releases..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ mb: 3 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
            />

            <ReleasesList releases={filteredReleases} />
        </ShContainer>
    );
}; 